import { Capacitor } from '@capacitor/core'
import { supabase } from './supabase'

let pushInitialized = false

export async function initPushNotifications(userId) {
  // Only run on native Android — not in browser
  if (!Capacitor.isNativePlatform()) return
  if (pushInitialized) return
  pushInitialized = true

  try {
    const { PushNotifications } = await import('@capacitor/push-notifications')

    // Request permission
    const result = await PushNotifications.requestPermissions()
    if (result.receive !== 'granted') {
      console.log('Push permission denied')
      return
    }

    // Create a high-importance channel so notifications show (and are LOUD)
    // even when the app is closed. channel_id must match the edge function.
    try {
      // High-importance channel — heads-up popup + loud sound (owner order alerts)
      await PushNotifications.createChannel({
        id: 'syninn_orders_v3',
        name: 'New Orders (Loud Alerts)',
        description: 'Loud, pop-up alerts for new orders and bookings',
        importance: 5,              // MAX — heads-up popup + sound
        visibility: 1,
        sound: 'buzz.wav',
        vibration: true,
        lights: true,
        lightColor: '#C9A84C',
      })
      // Normal channel — quiet panel notifications (customer updates)
      await PushNotifications.createChannel({
        id: 'syninn_updates',
        name: 'Updates',
        description: 'Order status and general updates',
        importance: 3,              // DEFAULT — panel notification, no screen pop
        visibility: 1,
        sound: 'default',
        vibration: true,
        lights: true,
        lightColor: '#C9A84C',
      })
      console.log('Notification channels created')
    } catch (e) {
      console.log('Channel create skipped:', e)
    }

    // Register with FCM
    await PushNotifications.register()

    // Save FCM token to Supabase
    PushNotifications.addListener('registration', async (token) => {
      if (!token?.value || !userId) return
      try {
        await supabase.from('push_tokens').upsert({
          user_id: userId,
          token: token.value,
          platform: 'android',
          updated_at: new Date().toISOString(),
        }, { onConflict: 'user_id,token' })
        console.log('FCM token saved')
      } catch (err) {
        console.error('Token save error:', err)
      }
    })

    // Handle notification received while app is open
    PushNotifications.addListener('pushNotificationReceived', (notification) => {
      console.log('Notification received in foreground:', notification.title)
      // App is open — you can show an in-app banner here if needed
    })

    // Handle notification tap
    PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      console.log('Notification tapped:', action.notification.data)
      // Navigate based on notification type if needed
    })

    PushNotifications.addListener('registrationError', (err) => {
      console.error('FCM registration error:', err)
    })

  } catch (err) {
    console.error('Push init error:', err)
  }
}

export async function removePushToken(userId) {
  if (!userId) return
  try {
    await supabase.from('push_tokens').delete().eq('user_id', userId)
  } catch (err) {
    console.error('Token remove error:', err)
  }
}